import {
  ResponseClustersData,
  ResponseClustersDataApi,
  LeadTimesData,
  LeadTimesDataApi
} from './interfaces'

export const toResponseClustersData = (
  responseClustersDataApi: ResponseClustersDataApi
): ResponseClustersData => {
  return {
    pagination: responseClustersDataApi.pagination,
    data: toLeadTimesData(responseClustersDataApi.data)
  }
}

export const toLeadTimesData = (leadTimesApi: LeadTimesDataApi[]): LeadTimesData[] => {
  return leadTimesApi.map((item) => ({
    material: item.material,
    description: item.description,
    technology: item.technology,
    leadTime: item.leadTime,
    keyAccountsTime: item.LeadTimeCliente // NOTE: Assuming property LeadTimeCliente as keyAccountsTime
  }))
}
